// extracted by mini-css-extract-plugin
export default {"wrapper":"PowerFactor_wrapper__66v0x","left":"PowerFactor_left__2jd9v","label":"PowerFactor_label__laJiK","value":"PowerFactor_value__jyQ3D","right":"PowerFactor_right__Lcsz7"};